import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Outlet, Link } from "react-router-dom";
import Footer from "./Footer.js";
import ArrowRight from "./ArrowRight.js";
import ArrowLeft from "./ArrowLeft.js";
import HoriLine from "./HoriLine.js";
import BlobLeft from "./BlobLeft.js";
import BlobRight from "./BlobRight.js";
import Box from '@mui/material/Box';
import LinearProgress from "@mui/material/LinearProgress";
import { ThemeProvider } from '@mui/material/styles';
import JalostusMob from './JalostusMob.js';
import { BrowserView, MobileView, isBrowser, isMobile } from 'react-device-detect';




let firstElaLoad = true;

let elavideo = [];

elavideo.push( <video key="elavideo" width="auto" height="450vh" autoPlay="true" muted="true" mute="true" loop="true" playsInline="true" disablePictureInPicture="true" onCanPlay={elaCanPlay} src={window.JALOSTUSTEKSTIT.tokaosiovideo} type="video/mp4" /> );

function elaCanPlay(e)
{
	//console.log(e);
	//console.log("I can now play in Ela");
	window.jalostusVideoCanPlay = true;
}

let stopupdates = function () {};


function Jalostus(p)
{
	//console.log("Paint");
	let [progress, pupdate] = React.useState(0);
	let [progressLp, pupdateLp] = React.useState(0);
	let [nomoreload, nomoreupdate] = React.useState(<div></div>);

	stopupdates = nomoreupdate;

	React.useEffect( () => { if ( window.RECENTLOAD )  window.drawJalostus(); });
	if (! (window.KAIKKIJALOSTUSKUVATLADATTU && window.jalostusVideoCanPlay) )
	{
		function loopy()
		{
			if (! (window.KAIKKIJALOSTUSKUVATLADATTU && window.jalostusVideoCanPlay ))
			{
				setTimeout(loopy, 500);
				//console.log("Set new timeout");
			}
			else
			{
				let empty = [];
				stopupdates(empty);
				//console.log("Stopping timeout");
			}
			pupdate((window.allmedia.jalostus.length + window.allmedia.jalostusv.length) + " images out of " + window.allmedia.jalostuss);
			let addition = 0;
			if (window.jalostusVideoCanPlay) addition = 10;
			pupdateLp((90 * (window.allmedia.jalostus.length/window.allmedia.jalostuss)) + addition);
		}
		setTimeout(loopy, 1000);
		let cont = [];
		if (firstElaLoad) firstElaLoad = false;
		else cont = elavideo;
		return(	<div> <ThemeProvider theme={window.MUIthemeWhite}>
			<div className="keskitetty" style={{color: "#000000", fontSize: "125%"}}>
				<div>Ladataan:</div>
				<div>
    	  				<LinearProgress variant="determinate" value={progressLp} />
				</div>
			</div></ThemeProvider><div style={{ display:"none" }}> {cont} {nomoreload} </div> </div>);
	}
	else
	{
		if (isMobile && window.NOTIPAD)
		{
			return (<JalostusMob elavideo={elavideo}/>);
		}
		else
		{

			let curWidth = "" + (window.innerWidth -  100) + "px";
			return(<div style={{color: "#000000", fontSize: "125%"}}>
			<div key="jalostusosioeka" className="kuvallinenvasen">
				<div>
					<h1>{window.JALOSTUSTEKSTIT.ekaosio}</h1>
					<div key="gapihmomia" className="otsikkogap"></div>
					{window.JALOSTUSTEKSTIT.ekaosioekar}
					<div key="gapihmomib" className="paragap"></div>
					{window.JALOSTUSTEKSTIT.ekaosiotokar}
				</div>
				<div style={{justifyContent:"right", alignItems: "right", textAlign: "right"}}>
					<img height="500vh" src={window.JALOSTUSTEKSTIT.ekaosiokuva} />
				</div>
			</div>
			<HoriLine fromcolor="rgb(255, 255, 255)" tocolor="rgb(235,225,210)"/>
			<div key="gapihmomic" className="osiogap"></div>
			<div className="vasenlevea">
				<h3>{window.JALOSTUSTEKSTIT.tokaosioekar}</h3>
			</div>
			<BlobLeft fromcolor="rgb(255, 255, 255)" tocolor="rgb(235,225,210)" />
			<div key="gapihmomid" className="osiogap"></div>
			<div key="jalostusosiotoka" className="kuvallinenoikeakapea">
				<div>
					<div style={{position: "absolute",
							clipPath: "polygon(16% 7%, 16% 100%, 92% 100%, 92% 7%)"
	}}>
						{elavideo}
					</div>
					<div style={{position: "absolute"}}>
						<img height="500vh" src={window.JALOSTUSTEKSTIT.tokaosiokuva} />
					</div>
				</div>
				<div style={{ display: "grid", gridTemplateColumns: "1fr", gridTemplateRows: "repeat(auto-fit, minmax(100px, auto))", justifyItems: "center", alignItems: "center"}} >
					<div style={{height:"10vh"}}></div>
					<div style={{display: "inline-block", verticalAlign: "middle", lineHeight:"1"}}>
						<div>
						{window.JALOSTUSTEKSTIT.tokaosiotokar}
						</div>
						<h3>
						{window.JALOSTUSTEKSTIT.tokaosiokolmasr}
						</h3>
					</div>
				</div>
			</div>
			<div key="gapihmomie" className="osiogap"></div>
			<div key="gapihmomif" className="osiogap"></div>
			<div key="gapihmomig" className="osiogap"></div>
			<div key="gapihmomih" className="osiogap"></div>
			<div key="gapihmomii" className="osiogap"></div>
			<div key="gapihmomij" className="osiogap"></div>
			<div key="gapihmomik" className="osiogap"></div>
			<BlobRight fromcolor="rgb(255, 255, 255)" tocolor="rgb(235,225,210)" />
			<div key="jalostusosiokolmas" className="kuvallinenvasenkapea">
				<div>
					{window.JALOSTUSTEKSTIT.neljasosioekar}
				</div>
				<div>
				</div>
			</div>
			<div key="gapihmomil" className="osiogap"></div>
			<div className="keskitetty" style={{fontFamily: "montsB"}}>
				{window.JALOSTUSTEKSTIT.neljasosiotokar}
			</div>
			<div key="gapihmomim" className="osiogap"></div>
			<div key="gapihmomin" className="osiogap"></div>
			<div key="gapihmomio" className="osiogap"></div>
			<div key="gapihmomiola" className="osiogap"></div>
			<div key="gapihmomiolb" className="osiogap"></div>
			<div className="seuraavasivu">
				<div className="seuraavasivuotsikko" >
					<Link to="../automaatio" style={{textDecoration: "none", verticalAlign: "middle"}} onClick={moveToAutomaatio}>
						<span style={{color: "#000000", fontSize:"2em", fontWeight:"bold", verticalAlign: "middle"}}>AUTOMAATIO</span>
					</Link>
				</div>
				<div style={{transform: "scale(0.75)"}}>
					<Link to="../automaatio" style={{textDecoration: "none", verticalAlign: "middle"}} onClick={moveToAutomaatio}>
						<ArrowRight stroke="#000000"/>
					</Link>
				</div>
			</div>

		</div>);
		}
	}
}

/*

				<video height= width= autoplay muted loop>
					<source src="" type="video/mp4"/>
					Selaimesi ei tue videoita.
				</video>


		<div style={{marginLeft:"20%", marginRight:"20%"}}>
			<div className="jalostuskortit" style={{verticalAlign: "center"}} >
				<img width="100%" src={window.JALOSTUSTEKSTIT.kortitdummykuva} />
			</div>
		</div>
		<div key="gapihmomi" className="osiogap"></div>
		<div key="jalostusneljasosio" className="kuvallinenoikeavasmargi">
			<div>
				<img height="300vh" src={window.JALOSTUSTEKSTIT.neljasosiokuva} />
			</div>
			<div></div>
			<div>
				{window.JALOSTUSTEKSTIT.neljasosioekar}
				<div key="gapihmomi" className="paragap"></div>
				<h3>{window.JALOSTUSTEKSTIT.neljasosiotokar}</h3>
			</div>
		</div>

		<div key="gapihmomi" className="osiogap"></div>
		<div className="vasen">
				{window.JALOSTUSTEKSTIT.viidesosioekar}
				<ul style={{listStyleImage: "url('"+window.JALOSTUSTEKSTIT.viidesosiobullet+"')"}}>
					<li>{window.JALOSTUSTEKSTIT.viidesosioekap}</li>
					<li>{window.JALOSTUSTEKSTIT.viidesosiotokap}</li>
					<li>{window.JALOSTUSTEKSTIT.viidesosiokolmasp}</li>
				</ul>
		</div>


*/

function moveToAutomaatio()
{
	window.SETAUTOMAATIO();
	window.drawAutomaatio();
}




export default Jalostus;
